export default __webpack_public_path__ + "static/media/share.431a5284.svg";